import * as Redux from "react-redux";

import { RootState } from "client/store";
import { getIntl, Translate } from "client/utils/internationalization";

// useTranslation hook with a useDefault array to specify sourcing specific
// translations from commonResource.json instead of the merchant's country
// resource.json
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useTranslation = (useDefault: string[] = []): Translate => {
  const registeredCountry = Redux.useSelector(
    ({ merchant }: RootState) =>
      merchant.fieldValueMap.companyInformation.registeredCountry
  );

  return getIntl(registeredCountry, useDefault);
};
